import React from "react";
import {
    Navigate
} from "react-router-dom";
import {getAccessToken} from "./authority";
import {jwtDecode} from "jwt-decode";
import pako from "pako";

// export function checkPermission(permission) {
//     const token = getAccessToken();
//     if (token === undefined){
//         return false;
//     }
//     const decodedToken = jwtDecode(token);
//     const list_permission = decodeBase64(decodedToken["authorities"])
//     if (list_permission.indexOf(permission) !== -1){
//         return true;
//     }
//     return false;
// }
/**
 * Kiểm tra quyền của user hiện tại
 * Quyền thực tế luôn lấy từ authorities trong JWT do server phát hành.
 * Không dùng danh sách hard-code theo roleType vì danh sách đó có thể lệch
 * với role_permission và làm ẩn các module đã được server cấp quyền.
 * @param {string} permission - Quyền cần kiểm tra (có thể chứa "|" để check nhiều quyền)
 * @returns {boolean} True nếu user có quyền
 */
export function checkPermission(permission) {
    const token = getAccessToken();
    if (token === undefined){
        return false;
    }

    try {
        const decodedToken = jwtDecode(token);
        const list_permission = decodeBase64(decodedToken["authorities"]);
        if (!list_permission) return false;

        const grantedPermissions = new Set(
            list_permission
                .replace(/^\[|\]$/g, "")
                .split(",")
                .map(p => p.trim())
                .filter(Boolean)
        );
        const permissionArr = permission.split("|").filter(p => p.trim() !== "");
        return permissionArr.some(p => grantedPermissions.has(p.trim()));

    } catch (error) {
        console.error("Error checking permission:", error);
        return false;
    }
}

/**
 * Lấy roleType của user hiện tại từ JWT token
 * @returns {string|null} roleType hoặc null nếu không có
 */
export function getCurrentRoleType() {
    const token = getAccessToken();
    if (token === undefined){
        return null;
    }

    try {
        const decodedToken = jwtDecode(token);
        return decodedToken["roleType"] || null;
    } catch (error) {
        console.error("Error getting roleType:", error);
        return null;
    }
}

/**
 * Kiểm tra user có phải là role CUSTOM không
 * @returns {boolean} True nếu là role CUSTOM hoặc không có roleType
 */
export function isCustomRole() {
    const roleType = getCurrentRoleType();
    return !roleType || roleType === "CUSTOM";
}
export function decodeBase64(base64String) {
    try {
        // Giải mã Base64
        const binaryString = atob(base64String);
        const binaryData = Uint8Array.from(binaryString, char => char.charCodeAt(0));

        // Giải nén GZIP
        const decompressedData = pako.inflate(binaryData, { to: 'string' });
        return decompressedData;
    } catch (error) {
        return null;
    }
}
export function RequireAuth({ children, redirectTo }) {
    let token = getAccessToken();
    return !!token ? children : <Navigate to={redirectTo} replace />;
}


export function RedirectAuth({ children, redirectTo }) {
    let token = getAccessToken();
    return !!token ? <Navigate to={redirectTo} replace />: children;
}
export function changeAlias(alias) {
    if(alias) {
        let str = alias;
        str = str.toLowerCase();
        str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
        str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
        str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
        str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
        str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
        str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
        str = str.replace(/đ/g, "d");
        str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
        str = str.replace(/ + /g, " ");
        str = str.trim();
        return str;
    }
    return alias;
}
